import React, { Fragment } from 'react';
import numeral from 'numeral';

import {
    Typography,
    Box,
    Grid,
    colors,
    makeStyles,
    Chip,
    Avatar
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {

    },
    labelvalue: {
        padding: 7
    },
    instrumenticon: {
        padding: 1,
        width: 155,
        height: 155
    },
    chipgreen: {
        backgroundColor: colors.green[400],
        width: 100,
        margin: 4
    },
    chipblue: {
        backgroundColor: colors.blue[400],
        width: 100,
        margin: 4
    },
    chipred: {
        backgroundColor: colors.red[600],
        width: 100,
        margin: 4,
        color: "#ffffff"
    },
    chipyellow: {
        backgroundColor: colors.yellow[900],
        width: 100,
        margin: 4,
        color: "#ffffff"
    }

}));


const INST04 = ({ instrument, message, event, instruments, alarm, device, schedules, commands, sendCommands }) => {

    const classes = useStyles();

    const getStateImage = (instrument, message, alarm) => {
        var alarmedin = false;
        var alarmedout = false;
        instrument.inputfields.map((infield) => {
            message.inputs.map((field) => {
                if (field.order === infield.fieldindex) {
                    if (!alarmedin && isAlarmedField(field, alarm)) {
                        alarmedin = true;
                    }
                }
            });
        });
        instrument.outputfields.map((infield) => {
            message.inputs.map((field) => {
                if (field.order === infield.fieldindex) {
                    if (!alarmedout && isAlarmedField(field, alarm)) {
                        alarmedout = true;
                    }
                }
            });
        });
        if (alarmedin && alarmedout) {
            return '/static/images/instruments/block_1.svg'
        } else if (alarmedin) {
            return '/static/images/instruments/block_2.svg';
        } else if (alarmedout) {
            return '/static/images/instruments/block_3.svg';
        } else {
            return '/static/images/instruments/block_4.svg'
        }
    }

    const isAlarmedField = (field, alarm) => {
        if (alarm === undefined || field === undefined) {
            return false;
        }
        if (Object.keys(alarm).length != 0) {
            var count = 0;
            alarm.fails.map((fail) => {
                if (fail.field.id == field._id && fail.type === 'fail') {
                    count++;
                }
            })
            return (count > 0);
        }
        return false
    }

    const isWarningField = (field, alarm) => {
        if (Object.keys(alarm).length != 0) {
            var count = 0;
            alarm.fails.map((fail) => {
                if (fail.field.id == field._id && fail.type === 'warn') {
                    count++;
                }
            })
            return (count > 0);
        }
        return false
    }

    return (
        <Fragment>
            <Box padding={1} margin={instrument.border} border={instrument.border} borderRadius={instrument.radius}
                borderColor={colors.grey[300]}>
                <Typography color="textSecondary" variant="h5" >
                    <b>{instrument.label}</b>
                </Typography>

                <Grid
                    container
                    direction="row"
                    justify="space-evenly"
                    alignItems="center"
                >

                    <Grid item xs="auto" key={instrument._id} >

                        {instrument.inputfields.map((infield, index) => (
                            message.inputs.map((field, index) => (
                                (field.order === infield.fieldindex) ? (
                                    <Grid
                                        container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="center"
                                    >
                                        <Grid item xs="auto">
                                            <Typography color="secondary" variant="body2" className={classes.labelvalue}  >
                                                {infield.label}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs="auto">
                                            {isAlarmedField(field, alarm) ? (
                                                <Chip className={classes.chipred}
                                                    size="small"
                                                    label={numeral(event.data[field.order]).format(field.format) + ` ` + field.sufix} />

                                            ) : (
                                                (isWarningField(field, alarm)) ? (
                                                    <Chip className={classes.chipyellow}
                                                        size="small"
                                                        label={numeral(event.data[field.order]).format(field.format) + ` ` + field.sufix} />

                                                ) : (
                                                    <Chip className={classes.chipblue}
                                                        size="small"
                                                        label={numeral(event.data[field.order]).format(field.format) + ` ` + field.sufix} />

                                                )
                                            )}
                                        </Grid>
                                    </Grid>
                                ) : (<div></div>)
                            ))
                        ))}

                        {instrument.outputfields.map((infield, index) => (
                            message.inputs.map((field) => (
                                (field.order === infield.fieldindex && (index >= instrument.inputfields.length)) ? (
                                    <Grid item xs="auto">
                                        <div>&nbsp;</div>
                                    </Grid>
                                ) : (<div></div>)
                            ))
                        ))}

                    </Grid>

                    <Grid item xs="auto">
                        <Avatar className={classes.instrumenticon} variant="square"
                            src={getStateImage(instrument, message, alarm)}>
                        </Avatar>
                    </Grid>

                    <Grid item xs="auto">
                        {instrument.outputfields.map((infield, index) => (
                            message.inputs.map((field, index) => (
                                (field.order === infield.fieldindex) ? (

                                    <Grid
                                        container
                                        direction="row"
                                        justify="flex-start"
                                        alignItems="center"
                                        key={field._id}
                                    >
                                        <Grid item xs="auto">

                                            {isAlarmedField(field, alarm) ? (
                                                <Chip className={classes.chipred}
                                                    size="small"
                                                    label={numeral(event.data[field.order]).format(field.format) + ` ` + field.sufix} />

                                            ) : (
                                                (isWarningField(field, alarm)) ? (
                                                    <Chip className={classes.chipyellow}
                                                        size="small"
                                                        label={numeral(event.data[field.order]).format(field.format) + ` ` + field.sufix} />

                                                ) : (

                                                    <Chip className={classes.chipgreen}
                                                        size="small"
                                                        label={numeral(event.data[field.order]).format(field.format) + ` ` + field.sufix} />

                                                )
                                            )}
                                        </Grid>

                                        <Grid item xs="auto">
                                            <Typography color="secondary" variant="body2" className={classes.labelvalue}>
                                                {infield.label}
                                            </Typography>
                                        </Grid>

                                    </Grid>

                                ) : (<div></div>)
                            ))
                        ))}

                        {instrument.inputfields.map((infield, index) => (
                            message.inputs.map((field) => (
                                (field.order === infield.fieldindex && (index >= instrument.outputfields.length)) ? (
                                    (
                                        <Grid item xs="auto">
                                            <div>&nbsp;</div>
                                        </Grid>
                                    )
                                ) : (<div></div>)
                            ))
                        ))}
                    </Grid>
                </Grid>

            </Box>
        </Fragment >
    );

}

export default INST04;